import PricingForm from './PricingForm';

export default PricingForm;
